import { trpc } from "../../main/components/trpc.ts";
import _ from "underts";
import CheckBox from "../../main/CheckBox.tsx";
import {Button} from "@/components/ui/button";
import ReminderConsentToggle from "./ReminderConsentToggle.tsx";

interface PatientSettingsPopupProps {
  patientId: string;
}

const PatientSettingsPopup = (props: PatientSettingsPopupProps) => {
  const { patientId } = props;
  const { data: patients } = trpc.patient.getByIds.useQuery({
    _ids: [patientId],
  });
  const patient = patients && _.first(patients);

  const isAncientPatient = !!patient?.former_patient;
  const utils = trpc.useUtils();
  const toggleFormerPatientMutation =
    trpc.patient.toggleFormerPatient.useMutation({
      onSuccess: () => {
        utils.patient.invalidate();
        utils.rdv.invalidate();
      },
    });

  const updatePatientMutation = trpc.patient.update.useMutation({
    onSuccess: () => {
      utils.patient.invalidate();
      utils.rdv.invalidate();
    },
  });

  const handleToggleAncientPatient = () => {
    toggleFormerPatientMutation.mutate(patientId);
  };

  const handleConsentChange = (
    key: "email_consent" | "sms_consent",
    value: boolean | null,
  ) => {
    updatePatientMutation.mutate({
      id: patientId,
      props: {
        [key]: value,
      },
    });
  };

  const handleAllowAll = () => {
    updatePatientMutation.mutate({
      id: patientId,
      props: {
        email_consent: true,
        sms_consent: true,
      },
    });
  };

  return (
    <div onClick={(e) => e.stopPropagation()} className="flex flex-col gap-2">
      <CheckBox
        checked={isAncientPatient}
        onChange={handleToggleAncientPatient}
        id="settingsPopup"
        label="Ancien patient avec rdvs non listés"
      />
      {patient ? (
        <>
          <div className="mt-2 flex items-center justify-between gap-2">
            <span className="font-medium">Autorisations rappels</span>
            <Button
              onClick={handleAllowAll}
              variant="secondary"
              size="sm"
              id="settings_popup_allow_all_reminders"
            >
              Tout autoriser
            </Button>
          </div>
          <ReminderConsentToggle
            value={patient.email_consent}
            onChange={(value) => handleConsentChange("email_consent", value)}
            id="settings_popup_email_consent"
            label="Autorisation mail"
          />
          <ReminderConsentToggle
            value={patient.sms_consent}
            onChange={(value) => handleConsentChange("sms_consent", value)}
            id="settings_popup_sms_consent"
            label="Autorisation SMS"
          />
        </>
      ) : null}
    </div>
  );
};

export default PatientSettingsPopup;
